import { render, staticRenderFns } from "./SubsectionDownloadModal.vue?vue&type=template&id=43234a5f&scoped=true&"
import script from "./SubsectionDownloadModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubsectionDownloadModal.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubsectionDownloadModal.vue?vue&type=style&index=0&id=43234a5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43234a5f",
  null
  
)

export default component.exports